export default {
  "zh_TW": {
    "discovery": {
      "newCoins": "鏈上新幣",
      "newDescription": "新上線代幣、價格、成交量與流動性",
      "calendar": "經濟日曆",
      "calendarDescription": "經濟數據公布與重要市場事件",
      "chain": "公鏈",
      "pageSort": "本頁排序",
      "newest": "最新上線",
      "volume": "成交量",
      "liquidity": "流動性",
      "marketCap": "市值",
      "change": "漲跌幅",
      "price": "價格",
      "token": "幣種",
      "listed": "首次報價",
      "refresh": "重新整理",
      "previous": "上一頁",
      "next": "下一頁",
      "page": "第 {page} / {total} 頁",
      "noData": "暫無資料",
      "date": "日期",
      "today": "今天",
      "importantOnly": "只看重要事件（3 星以上）",
      "timezone": "香港時間 · UTC+8",
      "economicData": "經濟數據",
      "events": "市場事件",
      "time": "時間",
      "event": "事件",
      "importance": "重要程度",
      "previousValue": "前值",
      "consensus": "預期值",
      "actual": "公布值",
      "pending": "待公布",
      "contact": "聯絡我們",
      "privacy": "隱私政策",
      "siteInfo": "網站資訊",
      "copyEmail": "複製信箱",
      "copied": "已複製",
      "copyFailed": "請選取並複製信箱地址",
      "related": "相關頁面",
      "allTokens": "全部代幣",
      "news": "新聞",
      "holders": "持有人",
      "timeTbd": "時間待定",
      "sourceLanguage": "原文：簡體中文"
    }
  },
  "zh_CN": {
    "discovery": {
      "newCoins": "链上新币",
      "newDescription": "新上线代币、价格、成交量与流动性",
      "calendar": "经济日历",
      "calendarDescription": "经济数据公布与重要市场事件",
      "chain": "公链",
      "pageSort": "本页排序",
      "newest": "最新上线",
      "volume": "成交量",
      "liquidity": "流动性",
      "marketCap": "市值",
      "change": "涨跌幅",
      "price": "价格",
      "token": "币种",
      "listed": "首次报价",
      "refresh": "刷新",
      "previous": "上一页",
      "next": "下一页",
      "page": "第 {page} / {total} 页",
      "noData": "暂无数据",
      "date": "日期",
      "today": "今天",
      "importantOnly": "只看重要事件（3 星以上）",
      "timezone": "香港时间 · UTC+8",
      "economicData": "经济数据",
      "events": "市场事件",
      "time": "时间",
      "event": "事件",
      "importance": "重要程度",
      "previousValue": "前值",
      "consensus": "预期值",
      "actual": "公布值",
      "pending": "待公布",
      "contact": "联系我们",
      "privacy": "隐私政策",
      "siteInfo": "网站信息",
      "copyEmail": "复制邮箱",
      "copied": "已复制",
      "copyFailed": "请选中并复制邮箱地址",
      "related": "相关页面",
      "allTokens": "全部代币",
      "news": "新闻",
      "holders": "持有人",
      "timeTbd": "时间待定",
      "sourceLanguage": "原文：简体中文"
    }
  },
  "en_US": {
    "discovery": {
      "newCoins": "New on-chain tokens",
      "newDescription": "Recently listed tokens, prices, volume and liquidity",
      "calendar": "Economic calendar",
      "calendarDescription": "Economic releases and important market events",
      "chain": "Chain",
      "pageSort": "Sort this page",
      "newest": "Newest",
      "volume": "Volume",
      "liquidity": "Liquidity",
      "marketCap": "Market cap",
      "change": "Change",
      "price": "Price",
      "token": "Token",
      "listed": "First quoted",
      "refresh": "Refresh",
      "previous": "Previous",
      "next": "Next",
      "page": "Page {page} of {total}",
      "noData": "No data available",
      "date": "Date",
      "today": "Today",
      "importantOnly": "Important only (3+ stars)",
      "timezone": "Hong Kong time · UTC+8",
      "economicData": "Economic releases",
      "events": "Market events",
      "time": "Time",
      "event": "Event",
      "importance": "Importance",
      "previousValue": "Previous",
      "consensus": "Forecast",
      "actual": "Actual",
      "pending": "Pending",
      "contact": "Contact us",
      "privacy": "Privacy policy",
      "siteInfo": "Site information",
      "copyEmail": "Copy email",
      "copied": "Copied",
      "copyFailed": "Select and copy the email address",
      "related": "Related pages",
      "allTokens": "All tokens",
      "news": "News",
      "holders": "Holders",
      "timeTbd": "Time TBD",
      "sourceLanguage": "Original: Simplified Chinese"
    }
  },
  "ja_JP": {
    "discovery": {
      "newCoins": "新規オンチェーントークン",
      "newDescription": "新規トークンの価格・取引量・流動性",
      "calendar": "経済カレンダー",
      "calendarDescription": "経済指標の発表と重要な市場イベント",
      "chain": "チェーン",
      "pageSort": "このページの並び順",
      "newest": "新しい順",
      "volume": "取引量",
      "liquidity": "流動性",
      "marketCap": "時価総額",
      "change": "騰落率",
      "price": "価格",
      "token": "トークン",
      "listed": "初回価格",
      "refresh": "更新",
      "previous": "前へ",
      "next": "次へ",
      "page": "{page} / {total} ページ",
      "noData": "データがありません",
      "date": "日付",
      "today": "今日",
      "importantOnly": "重要なイベントのみ（星3以上）",
      "timezone": "香港時間 · UTC+8",
      "economicData": "経済指標",
      "events": "市場イベント",
      "time": "時刻",
      "event": "イベント",
      "importance": "重要度",
      "previousValue": "前回",
      "consensus": "予想",
      "actual": "結果",
      "pending": "発表待ち",
      "contact": "お問い合わせ",
      "privacy": "プライバシーポリシー",
      "siteInfo": "サイト情報",
      "copyEmail": "メールをコピー",
      "copied": "コピーしました",
      "copyFailed": "メールアドレスを選択してコピーしてください",
      "related": "関連ページ",
      "allTokens": "すべてのトークン",
      "news": "ニュース",
      "holders": "保有者",
      "timeTbd": "時刻未定",
      "sourceLanguage": "原文：中国語（簡体字）"
    }
  },
  "ko_KR": {
    "discovery": {
      "newCoins": "신규 온체인 토큰",
      "newDescription": "신규 토큰 가격, 거래량 및 유동성",
      "calendar": "경제 캘린더",
      "calendarDescription": "경제 지표 발표 및 주요 시장 일정",
      "chain": "체인",
      "pageSort": "현재 페이지 정렬",
      "newest": "최신순",
      "volume": "거래량",
      "liquidity": "유동성",
      "marketCap": "시가총액",
      "change": "등락률",
      "price": "가격",
      "token": "토큰",
      "listed": "최초 가격 시점",
      "refresh": "새로고침",
      "previous": "이전",
      "next": "다음",
      "page": "{page} / {total} 페이지",
      "noData": "데이터가 없습니다",
      "date": "날짜",
      "today": "오늘",
      "importantOnly": "주요 일정만 (별 3개 이상)",
      "timezone": "홍콩 시간 · UTC+8",
      "economicData": "경제 지표",
      "events": "시장 일정",
      "time": "시간",
      "event": "일정",
      "importance": "중요도",
      "previousValue": "이전",
      "consensus": "예상",
      "actual": "발표",
      "pending": "발표 대기",
      "contact": "문의하기",
      "privacy": "개인정보 처리방침",
      "siteInfo": "사이트 정보",
      "copyEmail": "이메일 복사",
      "copied": "복사됨",
      "copyFailed": "이메일 주소를 선택하여 복사하세요",
      "related": "관련 페이지",
      "allTokens": "모든 토큰",
      "news": "뉴스",
      "holders": "보유자",
      "timeTbd": "시간 미정",
      "sourceLanguage": "원문: 중국어 간체"
    }
  }
};
